// extracted by mini-css-extract-plugin
module.exports = {"box":"DashboardCardBox_box__2I1kw","box_quantity":"DashboardCardBox_box_quantity__ZUc_d","box_label":"DashboardCardBox_box_label__YffdK"};